import {
  ACTIVITY_FORMS_NUMBERS,
  ACTIVITY_FORMS_ORDER
} from 'pages/create-activity/constants';

export const isNextStepAvailable = (
  forms,
  languages,
  newActiveTab,
  savedForms,
  scheduleActiveSubTab,
  pricesActiveSubTab
) => {
  let newActiveTabCopy = newActiveTab;
  const activityType = forms['generalForm'].values.activityType;

  while (newActiveTabCopy > 0) {
    let formName = ACTIVITY_FORMS_ORDER[newActiveTabCopy - 1];

    if (typeof formName === 'object') {
      formName = formName[scheduleActiveSubTab];

      if (typeof formName === 'object') {
        if (activityType === 'Open') {
          let pricesActiveSubTabIsOpen = pricesActiveSubTab;
          pricesActiveSubTabIsOpen++;
          formName = formName[pricesActiveSubTabIsOpen];
        } else {
          formName = formName[pricesActiveSubTab];
        }
      } else {
        let pricesActiveSubTabIsOpen = pricesActiveSubTab;
        if (activityType === 'Open') {
          pricesActiveSubTabIsOpen++;
        }
        const priceTabName =
          ACTIVITY_FORMS_ORDER[ACTIVITY_FORMS_NUMBERS.pricesForm][
            scheduleActiveSubTab
          ][pricesActiveSubTabIsOpen];
        if (
          (priceTabName === 'pricesDailyForm' ||
            priceTabName === 'pricesDailyScheduleForm') &&
          !forms['pricesDailyForm'].values.days.length &&
          !forms['pricesDailyScheduleForm'].values.daysArray.length
        ) {
          return false;
        }
      }

      if (formName === 'schedulePassForm' && !savedForms['schedulePassForm']) {
        return false;
      }
      if (
        forms[formName] &&
        (forms[formName].syncErrors || !savedForms[formName])
      )
        return false;
    } else {
      const languagesLength = languages.length;
      const secondLanguage = languages[languagesLength - 1];

      if (languagesLength > 1 && formName === 'addOnsForm') {
        const addOnsSecondLanguageForm = forms[formName].values;
        for (let i in addOnsSecondLanguageForm.addOns) {
          if (!addOnsSecondLanguageForm.addOns.hasOwnProperty(i)) continue;
          const addOns = addOnsSecondLanguageForm.addOns[i][secondLanguage];
          if (!addOns.title) return false;
        }
      }

      if (
        languagesLength > 1 &&
        (formName === 'generalForm' || formName === 'descriptionForm')
      ) {
        const secondLanguageFormName = `${formName}-${secondLanguage}`;
        if (
          languagesLength > 1 &&
          forms[secondLanguageFormName] &&
          (forms[secondLanguageFormName].syncErrors ||
            !Object.keys(savedForms[secondLanguageFormName]).length)
        ) {
          return false;
        }
      }

      if (
        forms[formName] &&
        (forms[formName].syncErrors || !savedForms[formName])
      )
        return false;
    }
    newActiveTabCopy--;
  }

  return true;
};

export const isCurrentStepAvailable = (
  forms,
  activeTab,
  scheduleActiveSubTab,
  pricesActiveSubTab
) => {
  let activeFormName = '';

  if (activeTab === ACTIVITY_FORMS_NUMBERS.scheduleForm) {
    activeFormName = ACTIVITY_FORMS_ORDER[activeTab][scheduleActiveSubTab];
  } else if (activeTab === ACTIVITY_FORMS_NUMBERS.pricesForm) {
    const pricesTabIndex =
      forms['generalForm'].values.activityType === 'Open'
        ? pricesActiveSubTab + 1
        : pricesActiveSubTab;
    activeFormName =
      ACTIVITY_FORMS_ORDER[activeTab][scheduleActiveSubTab][pricesTabIndex];
  } else {
    activeFormName = ACTIVITY_FORMS_ORDER[activeTab];
  }

  if (forms[activeFormName].syncErrors) {
    return false;
  }

  return true;
};
